<template>
  <div class="home contentBack">
    <div class="content-back">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="content-right">
          <!-- 地图区域 -->
          <div class="map">
            <div class="search-title">
              <div class="search-sub">
                乐山市趋势地图
                <span class="title-line"></span>
              </div>
              <div class="analy-one">
                <div class="analySelect-one">
                  <i class="iconfont" style="font-size: 17px; color: #272727"
                    >&#xe6c4;</i
                  >
                  <el-select
                    v-model="regionValue"
                    placeholder="请选择"
                    @change="getIndexData"
                  >
                    <el-option
                      v-for="item in regions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="timeblock-one">
                  <i class="iconfont" style="font-size: 17px; color: #272727"
                    >&#xe6cd;</i
                  >
                  <el-cascader
                    v-model="timevalue"
                    :options="options"
                    @change="handleTimeChange"
                  >
                  </el-cascader>
                </div>
              </div>
            </div>
            <!-- 地图 -->
            <div ref="maparea" style="min-width: 400px; height: 480px"></div>
            <!-- <div
              class="add-area"
              v-for="(item, a) in addArea"
              :key="item.id"
              @click="getAddArea"
            >
              <div :class="sstt[a]">
                <i class="iconfont" style="color: #8be2ba; font-size: 12px"
                  >&#xe6e6;</i
                >
                <span>{{ item.label }}</span>
              </div>
            </div> -->
          </div>
          <!-- 表格数据展示区域 -->
          <div class="table-data">
            <div class="table-data-left">
              <div class="table-header">
                <div class="analySelect-two">
                  <el-select v-model="trandeValue" @change="getTableLeft">
                    <el-option
                      v-for="item in trandeArea"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                
                <div class="downup" @click="downLoadFile()">导出</div>
              </div>
              <div class="other-tips">
                  注：“其他”表示暂时无法识别商标或专利所属区
                </div>
              <div class="number-list">
                <el-table :data="areaTmApPeople" stripe border height="380">
                  <el-table-column type="index" label="排序" width="50">
                  </el-table-column>
                  <el-table-column prop="cnty" label="地区"> </el-table-column>
                  <el-table-column
                    prop="num"
                    label="区域商标申请人量"
                    v-if="trandeValue == 'areaTmApPeople'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="区域专利申请人量"
                    v-if="trandeValue == 'areaPtApPeople'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="区域专利授权量"
                    v-if="trandeValue == 'areaPtAuNum'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="区域商标注册量"
                    v-if="trandeValue == 'areaTmRegNum'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="区域地理标志商标量(累计)"
                    v-if="trandeValue == 'areaDlbzNum'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="区域地理标志产品(累计)"
                    v-if="trandeValue == 'areaDbcpNum'"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="table-data-right">
              <div class="table-header">
                <div class="analySelect-two">
                  <el-select v-model="companyValue" @change="getTableRight">
                    <el-option
                      v-for="item in companyArea"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="downup" @click="downLoadFileRight()">导出</div>
              </div>
              <div class="number-list">
                <el-table :data="RightDataNew" stripe border height="380" style="margin-top: 33px;">
                  <el-table-column type="index" label="排序" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="ap"
                    label="企业名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="企业商标申请量"
                    v-if="companyValue == 'coTmApNum'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="企业专利申请量"
                    width="120"
                    v-if="companyValue == 'coPtApNum'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="企业商标注册量"
                    v-if="companyValue == 'coTmRegNum'"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="num"
                    label="企业专利授权量"
                    v-if="companyValue == 'coPtAuNum'"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>

        <!-- 折线图区域 -->
        <div class="line-map">
          <div class="common-map" style="height: 325px; margin-bottom: 10px">
            <div class="line-map-header">
              <div class="line-map-header-left">
                <div class="header-title">国内专利申请/授权趋势</div>
              </div>
              <div class="check-echart">
                <div
                  @click="switchEchart(1)"
                  :class="{ checked: echartsType1 == 1 }"
                >
                  <i class="iconfont">&#xe6e0;</i>
                  <p>折线图</p>
                </div>
                <div
                  @click="switchEchart(2)"
                  :class="{ checked: echartsType1 == 2 }"
                >
                  <i class="iconfont">&#xe6cd;</i>
                  <p>数据视图</p>
                </div>
              </div>
            </div>
            <div v-show="havedata1">
              <div
                id="patent-chart"
                style="height: 324px; width: 99%"
                v-show="echartsType1 == 1"
              ></div>
              <div class="map-list" v-show="echartsType1 == 2">
                <el-table :data="ptApplyTable" stripe border>
                  <el-table-column prop="month" label="时间" width="50">
                  </el-table-column>
                  <el-table-column prop="apply" label="申请量">
                  </el-table-column>
                  <el-table-column prop="author" label="授权量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata1" class="blankimg-home">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <div class="common-map" style="height: 325px; margin-bottom: 10px">
            <div class="line-map-header">
              <div class="line-map-header-left">
                <div class="header-title">国内商标申请/注册趋势</div>
              </div>
              <div class="check-echart">
                <div
                  @click="switchEchart(3)"
                  :class="{ checked: echartsType2 == 3 }"
                >
                  <i class="iconfont">&#xe6e0;</i>
                  <p>折线图</p>
                </div>

                <div
                  @click="switchEchart(4)"
                  :class="{ checked: echartsType2 == 4 }"
                >
                  <i class="iconfont">&#xe6cd;</i>
                  <p>数据视图</p>
                </div>
              </div>
            </div>
            <div
              id="trademark-chart"
              style="height: 324px; width: 99%"
              v-show="echartsType2 == 3 && havedata2"
            ></div>

            <div class="map-list" v-show="echartsType2 == 4 && havedata2">
              <el-table :data="tmTableTable" stripe border>
                <el-table-column prop="month" label="时间" width="50">
                </el-table-column>
                <el-table-column prop="apply" label="申请量" width="200">
                </el-table-column>
                <el-table-column prop="reg" label="注册量"> </el-table-column>
              </el-table>
            </div>
            <div v-show="!havedata2" class="blankimg-home">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <div class="common-map" style="height: 345px">
            <div class="line-map-header">
              <div class="line-map-header-left">
                <div class="header-title">商标国际分类注册量TOP10</div>
              </div>
            </div>
            <div
              id="bar-chart"
              style="height: 324px; width: 99%"
              v-show="havedata3"
            ></div>
            <div v-show="!havedata3" class="blankimg-home">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        </div>

        <!-- 折线图区域 end-->
      </div>
      <!-- 底部数据内容 -->
      <div class="list-bottom">
        <div class="list-top">
          <div class="home-list-title">
            <div class="home-subtitle">统计盘点</div>
          </div>
          <div class="list-out">
            <el-button size="mini" @click="ExportAreaExcel()"
              >导出Excel</el-button
            >
          </div>
        </div>
        <!--企业概况  -->
        <div class="home-list-content">
          <div class="homeList" style="width: 20%;min-width: 240px;max-width: 305px;">
            <div>●&nbsp;&nbsp;&nbsp;主体概况</div>
            <ul>
              <li v-for="(item, index) of firmsmsg" :key="index">
                {{ item.title }}：
                <span class="indexspan">{{ item.value }}</span>
              </li>
            </ul>
          </div>
          <!--专利统计  -->
          <div class="homeList" style="width: 40%">
            <div>●&nbsp;&nbsp;&nbsp;专利概况<div class="homelist-tips">注：统计维度为专利地址在乐山</div></div>
            <ul>
              <li v-for="(item, index) of patentCount" :key="index">
                {{ item.title }}：
                <span class="indexspan">{{ item.value }}</span>
              </li>
            </ul>
          </div>
          <!--商标统计  -->
          <div class="homeList" style="width: 35%">
            <div>●&nbsp;&nbsp;&nbsp;商标概况</div>
            <ul>
              <li v-for="(item, index) of trademarkCount" :key="index">
                {{ item.title }}：
                <span class="indexspan">{{ item.value }}</span>
              </li>
            </ul>
          </div>
          <!--集成电路统计  -->
          <!-- <div class="homeList" style="width: 18%">
            <div>●&nbsp;&nbsp;&nbsp;集成电路布图设计概要</div>
            <ul>
              <li v-for="(item, index) of IntegratedCount" :key="index">
                {{ item.title }}：
                <span class="indexspan">{{ item.value }}</span>
              </li>
            </ul>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
// import {downLoadOrder} from '../request/api'
// import BaseTable from "./BaseTable/index.vue";
import * as echarts from "echarts";
// import "../assets/js/diagrams/mianyang.json";
import { Header } from "element-ui";
// import Homeview from '../assets/js/diagrams/Homeview'
export default {
  name: "home",
  data() {
    return {
      // 新增区域地图样式
      sstt: ["ss1", "ss2", "ss3", "ss4"],

      addArea: [
        { id: "01", label: "高新区" },
        { id: "02", label: "经开区" },
        { id: "03", label: "科技城新区" },
        { id: "04", label: "仙海区" },
      ],
      mapSelParam: null,
      echart: {
        title: "", //选中的省份
        zoom: 0.4,
      },
      visible1: true,
      visible: true,
      timevalue: [],
      token: localStorage.getItem("token"),
      uid: localStorage.getItem("uid"),
      // 切换图表
      echartsType1: 1,
      echartsType2: 3,
      havedata1: true,
      havedata2: true,
      havedata3: true,
      trendApList: ["33333"],
      // airDate: [
      //   { name: "平武县", value: 50 },
      //   { name: "江油市", value: 10 },
      //   { name: "盐亭县", value: 113 },
      //   { name: "游仙区", value: 80 },
      //   { name: "三台县", value: 60 },
      // ],

      firstscroll1: true,
      firstscroll2: true,
      firstscroll3: true,
      firstscroll4: true,
      firstscroll5: true,
      firstscroll6: true,
      regionValue: "全部区域",
      yearValue: "01",
      regions: [
        { value: "全部区域", label: "全部区域", disabled: true },
        { value: "市中区", label: "市中区", disabled: true },
        { value: "五通桥区", label: "五通桥区", disabled: true },
        { value: "沙湾区", label: "沙湾区", disabled: true },
        { value: "金口河区", label: "金口河区", disabled: true },
        { value: "峨眉山市", label: "峨眉山市", disabled: true },
        { value: "犍为县", label: "犍为县", disabled: true },
        { value: "井研县", label: "井研县", disabled: true },
        { value: "夹江县", label: "夹江县", disabled: true },
        { value: "沐川县", label: "沐川县", disabled: true },
        { value: "峨边彝族自治县", label: "峨边彝族自治县", disabled: true },
        { value: "马边彝族自治县", label: "马边彝族自治县", disabled: true },
      ],
      // 选择时间
      timevalueS: "",
      options: [
        {
          value: "2021",
          label: "2021年",
          children: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "1",
              label: "第一季度",
            },
            {
              value: "2",
              label: "第二季度",
            },
            {
              value: "3",
              label: "第三季度",
            },
            {
              value: "4",
              label: "第四季度",
            },
          ],
        },
        {
          value: "2020",
          label: "2020年",
          children: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "1",
              label: "第一季度",
            },
            {
              value: "2",
              label: "第二季度",
            },
            {
              value: "3",
              label: "第三季度",
            },
            {
              value: "4",
              label: "第四季度",
            },
          ],
        },
      ],
      trandeArea: [
        {
          value: "areaTmApPeople",
          label: "区域商标申请人量",
        },
        {
          value: "areaPtApPeople",
          label: "区域专利申请人量",
        },
        {
          value: "areaPtAuNum",
          label: "区域专利授权量",
        },
        {
          value: "areaTmRegNum",
          label: "区域商标注册量",
        },
        {
          value: "areaDlbzNum",
          label: "区域地理标志商标量(累计)",
        },
        {
          value: "areaDbcpNum",
          label: "区域地理标志产品(累计)",
        },
      ],

      companyArea: [
        {
          value: "coTmApNum",
          label: "企业商标申请量",
        },
        {
          value: "coPtApNum",
          label: "企业专利申请量",
        },
        {
          value: "coTmRegNum",
          label: "企业商标注册量",
        },
        {
          value: "coPtAuNum",
          label: "企业专利授权量",
        },
      ],
      trandeValue: "areaTmApPeople",
      companyValue: "coTmApNum",
 
      column: [
        {
          prop: "date",
          label: "时间",
        },
        {
          prop: "name",
          label: "申请量",
        },
        {
          prop: "address",
          label: "授权量",
        },
      ],
      tableLabel: {
        sort: "排序",
        area: "地区",
        peopelNum: "专利申请人数",
      },
      countData: [],

      echartData: {
        order: {
          xData: [],
          series: [],
        },
        user: {
          xData: [],
          series: [],
        },
        video: {
          series: [],
        },
      },
      firmsmsg: [
        { title: "当年新增企业注册", value: "1" },
        // { title: "注册登记企业", value: "58" },
        { title: "个人数量", value: "58" },
        { title: "企业数量", value: "58" },
        { title: "高新技术企业", value: "852" },
        { title: "规上企业", value: "23" },
        { title: "专精特新企业", value: "454" },
        { title: "融合发展企业", value: "435" },
      ],
      patentCount: [
        // { title: "国内发明专利量", value: "4523" },
        { title: "国内发明专利授权量(累计)", value: "0" },//1
        { title: "当年国内发明专利授权量", value: "3424" },//4
        { title: "国内发明专利有效量(累计)", value: "0" },//3
        { title: "当年国内专利申请量", value: "" },//6
        { title: "国内专利申请(已公开)量(累计)", value: "" },//5
        { title: "(已公开)当年国内发明专利申请量", value: "" },//8
        { title: "万人发明专利拥有量(累计)", value: "" },//7
        { title: "（已公开）当年PCT申请量", value: "" },//10
        { title: "万人价值较高发明专利拥有量(累计)", value: "" },//9
        { title: "区域累计PCT专利申请(已公开)量", value: "32" },//12
        { title: "区域累计专利授权量", value: "" },//11
        { title: "当年国内专利授权量", value: "0" },//2
        { title: "区域累计有效专利量", value: "32" },//13
      ],
      trademarkCount: [
        { title: "国内商标申请量(累计)", value: "324" },
        { title: "当年国内商标申请量", value: "" },
        { title: "驰名商标量(累计)", value: "" },
        { title: "当年国内注册商标量", value: "32" },
        { title: "地理标志有效商标量(累计)", value: "" },
        { title: "当年马德里注册量", value: "" },
        { title: "地理标志产品量(累计)", value: "" },
        { title: "区域累计马德里商标注册量", value: "" },
        { title: "区域累计商标注册量", value: "" },
        { title: "区域累计有效商标量", value: "" },
      ],
      IntegratedCount: [
        { title: "目前布图设计有效量", value: "234" },
        { title: "当年布图设计公告量", value: "" },
        { title: "区域累计布图设计量", value: "" },
      ],
      ptApply: [],
      areaTmApPeople: [],
      RightDataNew: [],
      coPtApNum: [],
      areaRight: [],
      ptApplyTable: [], //表格数据
      tmTableTable: [],
      mianyangArr: [
        "市中区",
        "沙湾区",
        "五通桥区",
        "金口河区",
        "犍为县",
        "井研县",
        "夹江县",
        "沐川县",
        "峨边彝族自治县",
        "马边彝族自治县",
        "峨眉山市",
      ],
      echartApp: {},
    };
  },
  watch: {
    regionValue(n, o) {
      // console.log(">>",n)
      this.echartApp.setOption(this.getEchartsOptions(n));
      // console.log(">>11",this.mianyangObj)
      // this.getEchartsOptions(n)
    },
  },
  mounted() {
    //初始化地图
    this.initEcharts();
    // console.log('trandeValue',this.trandeValue)
    //   获取当前年
    let year = new Date().getFullYear();
    this.timevalueS = year;
    this.options[0].value = year;
    this.options[0].label = year + "年";
    this.options[1].value = year - 1;
    this.options[1].label = year - 1 + "年";
   
    // 获取当前时间全部
    // let year1 = new Date().getFullYear();
    // console.log('---------year',year1)
    // // 获取当前季度
    // let season = Math.floor((new Date().getMonth() + 3) / 3);
    let arr = [];
    this.$set(arr, 0, year);
    this.$set(arr, 1, "");
    this.timevalue = arr;
    // console.log("this.timevalue ", this.timevalue);
    this.timevalueS = this.timevalue.join("");
    // console.log("this.timevalueS ", this.timevalueS);

    this.getIndexData();
    // this.getTableLeft("areaTmApPeople");
    // this.getTableRight("coPtApNum");
  },

  methods: {
    initEcharts() {
      //初始化echarts
      this.echartApp = echarts.init(this.$refs.maparea);
      const res = require("../assets/js/diagrams/leshan.json");
      this.mianyangObj = res;
      echarts.registerMap("chinaMap", res);
      //设置配置项
      this.echartApp.setOption(this.getEchartsOptions());

      //点击各省份事件处理

      this.echartApp.on("click", (param) => {
        // console.log(param.name);
        // console.log(param.adcode)
        this.regionValue = param.name;
        this.$GET("/home/summary", {
          cnty: param.name,
          time: this.timevalueS,
        }).then((res) => {
          let obj1 = res.data;
          delete obj1.year;
          delete obj1.area;
          delete obj1.updateTime;

          this.firmsmsg[0].value = obj1.applicantThisYearNum;
          this.firmsmsg[1].value = obj1.personalNum;
          this.firmsmsg[2].value = obj1.companyNum;
          this.firmsmsg[3].value = obj1.HighTechNum;
          this.firmsmsg[4].value = obj1.statutoryNum;
          this.firmsmsg[5].value = obj1.zjtxNum;
          this.firmsmsg[6].value = obj1.rhfzNum;

          this.patentCount[0].value =  obj1.ptFmAuNum;
          this.patentCount[1].value =  obj1.ptInventionAuthThisYearNum;
          this.patentCount[2].value =  obj1.ptValidInventionNum;
          this.patentCount[3].value =  obj1.ptThisYearNum;
          this.patentCount[4].value =  obj1.ptNum;
          this.patentCount[5].value =  obj1.ptInventionThisYearNum;
          this.patentCount[6].value =  obj1.avgInventionNum;
          this.patentCount[7].value =  obj1.ptPctThisYearNum;
          this.patentCount[8].value =  obj1.avgHighValueNum;
          this.patentCount[9].value =  obj1.ptPctNum;
          this.patentCount[10].value =  obj1.ptAuthNum;
          this.patentCount[11].value = obj1.ptAuthThisYearNum;
          this.patentCount[12].value = obj1.ptInventionCumulativeNum;
          // this.patentCount[12].value = obj1.ptInventionCumulativeNum;

          this.trademarkCount[0].value = obj1.tmNum;
          this.trademarkCount[1].value = obj1.tmThisYearNum;
          this.trademarkCount[2].value = obj1.tmFamousNum;
          this.trademarkCount[3].value = obj1.tmRegisterThisYearNum;
          this.trademarkCount[4].value = obj1.tmGeographicNum;
          this.trademarkCount[5].value = obj1.tmMadridRegisterThisYearNum;
          this.trademarkCount[6].value = obj1.dbcpNum;
          this.trademarkCount[7].value = obj1.tmMadridRegisterNum;
          this.trademarkCount[8].value = obj1.tmRegisterNum;
          this.trademarkCount[9].value = obj1.tmValidNum;
          //  this.trademarkCount[8].value =obj1.ptAuthNum;
          //  this.trademarkCount[9].value =obj1.ptAuthNum;
          //  this.trademarkCount[10].value =obj1.ptAuthNum;

          this.IntegratedCount[0].value = obj1.vuIcdsNum;
          this.IntegratedCount[1].value = obj1.pbIcdsNum;
          this.IntegratedCount[2].value = obj1.icdsNum;

          this.$store.commit("ptApplydata", obj1);
          if (obj1.ptApply.length == 0) {
            this.havedata1 = false;
          } else {
            this.havedata1 = true;
            this.ptApplyTable = obj1.ptTable;
            // console.log("---", this.ptApplyTable);
          }
          if (obj1.tmApply.length == 0) {
            this.havedata2 = false;
          } else {
            this.havedata2 = true;
            this.tmTableTable = obj1.tmTable;
            // console.log("---", this.tmTableTable);
          }
          if (obj1.tmIcApply.length == 0 || obj1.tmIcReg.length == 0) {
            this.havedata3 = false;
          } else {
            this.havedata3 = true;
          }
          this.$myChart.line(
            "patent-chart",
            store.state.ptApplydataYapplyind,
            store.state.ptApplydataYagreeind,
            store.state.ptAuthorizationLine
          );

          this.$myChart.tmApply(
            "trademark-chart",
            store.state.tmApplyMonth,
            store.state.tmApplyNum,
            store.state.tmRegNum
          );

          this.$myChart.getBarChart(
            "bar-chart",
            store.state.tmIcApplyIc,
            store.state.tmIcRegNum,
            store.state.tmIcApplyNum,
            store.state.tmIcRegIc
          );
        });
        this.$GET("home/list", {
          cnty: param.name,
          time: this.timevalueS,
          token: this.token,
          uid: this.uid,
          ty: this.trandeValue,
        }).then((res) => {
          this.areaTmApPeople = res.data;
          let areaData = [];
          // console.log('this.areaTmApPeople',this.areaTmApPeople)
          Object.keys(this.areaTmApPeople).forEach((v) => {
            if (this.areaTmApPeople[v].length) {
              areaData = this.areaTmApPeople[v];
            }
          });
          this.areaTmApPeople = areaData;
          // console.log("areaData", this.areaTmApPeople);
        });
        this.$GET("home/list", {
          cnty: param.name,
          time: this.timevalueS,
          token: this.token,
          uid: this.uid,
          ty: this.companyValue,
        }).then((res) => {
          this.areaRight = res.data;
          let RightData = [];
          Object.keys(this.areaRight).forEach((v) => {
            if (this.areaRight[v].length) {
              RightData = this.areaRight[v];
            }
          });
          this.RightDataNew = RightData;
          // console.log("RightData", this.RightDataNew);
        });
      });
    },

    getEchartsOptions(name) {
      let data = {
        geo: {
          type: "map",
          map: "chinaMap",
          // roam: true,
          selectedMode: "single",
          aspectScale: 0.8, //长宽比
          zoom: 1.4,
          // regions: this.mianyangArr.map(item=>{
          //   if(item==name){
          //     return {
          //       name: name,
          //       itemStyle:{
          //         areaColor: '#1572D5',
          //       },
          //       selected:true
          //     }
          //   }else{
          //     return {
          //       selected:false
          //     }
          //   }
          // }),
          // [
          //   {
          //   name: '平武县',
          //   itemStyle: {
          //       areaColor: '#1572D5',
          //       color:'#ffffff'
          //   },
          //   // selected:true
          // }
          // ],
          // 设置中心点
          // center:[116.38162,36.5787],
          label: {
            normal: {
              show: true,
              fontSize: 12,
              color: "#000",
            },
            emphasis: {
              show: true,
              color: "#fff",
              areaColor: "#1572D5",
            },
          },
          select: {
            label: { color: "#fff" },
            itemStyle: {
              areaColor: "#1572D5",
              borderColor: "#1572D5",
              color: "#1572D5",
              textStyle: {
                color: "#fff", //鼠标经过字体颜色
              },
            },
          },

          grid: {
            left: 10,
            containLabel: true,
            bottom: 10,
            top: 10,
            right: 30,
          },

          emphasis: {
            // 地图颜色
            itemStyle: {
              show: true,
              color: "#fff",
              areaColor: "#1572D5", //鼠标滑过区域颜色
              label: {
                show: true,
                textStyle: {
                  color: "#fff",
                },
              },
            },
          },
        },

        //系列配置
        series: [
          {
            geoIndex: 0,
            type: "map",
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 8,
                },
              },
            },
            // data:[{name:"游仙区",value:0,selected:true}],
            itemStyle: {
              normal: {
                areaColor: "rgba(0,255,236,0)",
                borderColor: "rgba(0,0,0,0.2)",
              },
              emphasis: {
                // 选中的区域颜色及阴影效果等
                areaColor: "rgba(255,180,0,0.8)",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 20,
                borderWidth: 0,
              },
            },
          },
        ],
        animationType: "scale",
        animationEasing: "elasticOut",
        animationDelay: 2000,
      };
      if (
        this.mianyangArr.find((item) => {
          return item == name;
        })
      ) {
        data.geo.regions = [
          {
            name: name,
            itemStyle: {
              areaColor: "#1572D5",
            },
          },
        ];
      } else {
        data.geo.regions = [];
      }
      return data;
    },
    // 获取首页数据
    getIndexData() {
      let cnty;
      this.regions.forEach((ele) => {
        if (ele.value == this.regionValue) {
          cnty = ele.label;
        }
      });
      this.$GET("/home/summary", {
        cnty: cnty,
        time: this.timevalueS,
      }).then((res) => {
        let obj1 = res.data;
        delete obj1.year;
        delete obj1.area;
        delete obj1.updateTime;

   
          this.firmsmsg[0].value = obj1.applicantThisYearNum;
          this.firmsmsg[1].value = obj1.personalNum;
          this.firmsmsg[2].value = obj1.companyNum;
          this.firmsmsg[3].value = obj1.HighTechNum;
          this.firmsmsg[4].value = obj1.statutoryNum;
          this.firmsmsg[5].value = obj1.zjtxNum;
          this.firmsmsg[6].value = obj1.rhfzNum;

          this.patentCount[0].value =  obj1.ptFmAuNum;
          this.patentCount[1].value =  obj1.ptInventionAuthThisYearNum;
          this.patentCount[2].value =  obj1.ptValidInventionNum;
          this.patentCount[3].value =  obj1.ptThisYearNum;
          this.patentCount[4].value =  obj1.ptNum;
          this.patentCount[5].value =  obj1.ptInventionThisYearNum;
          this.patentCount[6].value =  obj1.avgInventionNum;
          this.patentCount[7].value =  obj1.ptPctThisYearNum;
          this.patentCount[8].value =  obj1.avgHighValueNum;
          this.patentCount[9].value =  obj1.ptPctNum;
          this.patentCount[10].value =  obj1.ptAuthNum;
          this.patentCount[11].value = obj1.ptAuthThisYearNum;
          this.patentCount[12].value = obj1.ptInventionCumulativeNum;
          // this.patentCount[12].value = obj1.ptInventionCumulativeNum;

        this.trademarkCount[0].value = obj1.tmNum;
        this.trademarkCount[1].value = obj1.tmThisYearNum;
        this.trademarkCount[2].value = obj1.tmFamousNum;
        this.trademarkCount[3].value = obj1.tmRegisterThisYearNum;
        this.trademarkCount[4].value = obj1.tmGeographicNum;
        this.trademarkCount[5].value = obj1.tmMadridRegisterThisYearNum;
        this.trademarkCount[6].value = obj1.dbcpNum;
        this.trademarkCount[7].value = obj1.tmMadridRegisterNum;
        this.trademarkCount[8].value = obj1.tmRegisterNum;
        this.trademarkCount[9].value = obj1.tmValidNum;
        //  this.trademarkCount[8].value =obj1.ptAuthNum;
        //  this.trademarkCount[9].value =obj1.ptAuthNum;
        //  this.trademarkCount[10].value =obj1.ptAuthNum;

        this.IntegratedCount[0].value = obj1.vuIcdsNum;
        this.IntegratedCount[1].value = obj1.pbIcdsNum;
        this.IntegratedCount[2].value = obj1.icdsNum;

        this.$store.commit("ptApplydata", obj1);
        if (obj1.ptApply.length == 0) {
          this.havedata1 = false;
        } else {
          this.havedata1 = true;
          this.ptApplyTable = obj1.ptTable;
          // console.log("---", this.ptApplyTable);
        }
        if (obj1.tmApply.length == 0) {
          this.havedata2 = false;
        } else {
          this.havedata2 = true;
          this.tmTableTable = obj1.tmTable;
          // console.log("---", this.tmTableTable);
        }
        if (obj1.tmIcApply.length == 0 || obj1.tmIcReg.length == 0) {
          this.havedata3 = false;
        } else {
          this.havedata3 = true;
        }
        this.$myChart.line(
          "patent-chart",
          store.state.ptApplydataYapplyind,
          store.state.ptApplydataYagreeind,
          store.state.ptAuthorizationLine
        );

        this.$myChart.tmApply(
          "trademark-chart",
          store.state.tmApplyMonth,
          store.state.tmApplyNum,
          store.state.tmRegNum
        );

        this.$myChart.getBarChart(
          "bar-chart",
          store.state.tmIcApplyIc,
          store.state.tmIcRegNum,
          store.state.tmIcApplyNum,
          store.state.tmIcRegIc
        );
      });
       this.getTableLeft("areaTmApPeople");
      this.getTableRight("coPtApNum");
      // this.getTableLeft("areaTmApPeople");
      // this.getTableRight("coPtApNum");
    },
    
    getAddArea(e) {
      this.regionValue = e.target.innerText;
      this.getIndexData();
      this.getTableLeft("areaTmApPeople");
      this.getTableRight("coPtApNum");
      // console.log("this.regionValue", this.regionValue);
    },
    // // 初始化值
    //   buildParam() {
    //   // let params = {current: this.pagination.current, pageSize: this.pagination.pageSize}
    //   if (this.trandeValue !== 'areaTmApPeople') {
    //     this.$set(params, 'searchType', this.trandeValue)
    //     // this.$set(params, 'param', this.param)
    //   }
    //   if (this.companyValue !== 'coTmApNum') {
    //     this.$set(params, 'companyValueName', this.companyValue)
    //   }
    //   return params
    // },
    //左边数据列表
    getTableLeft(val) {
      this.trandeValue = val;
      // console.log('this.trandeValue',this.trandeValue)
      let cnty;
      this.regions.forEach((ele) => {
        if (ele.value == this.regionValue) {
          cnty = ele.label;
        }
      });
      this.$GET("home/list", {
        cnty: cnty,
        time: this.timevalueS,
        token: this.token,
        uid: this.uid,
        ty: this.trandeValue,
      }).then((res) => {
        this.areaTmApPeople = res.data;
        let areaData = [];
        // console.log('this.areaTmApPeople',this.areaTmApPeople)
        Object.keys(this.areaTmApPeople).forEach((v) => {
          if (this.areaTmApPeople[v].length) {
            areaData = this.areaTmApPeople[v];
          }
        });
        this.areaTmApPeople = areaData;
        // console.log("areaData", this.areaTmApPeople);
      });
    },
    // 右边数据列表
    getTableRight(val) {
      this.companyValue = val;
      let cnty;
      this.regions.forEach((ele) => {
        if (ele.value == this.regionValue) {
          cnty = ele.label;
        }
      });
      this.$GET("home/list", {
        cnty: cnty,
        time: this.timevalueS,
        ty: this.companyValue,
      }).then((res) => {
        this.areaRight = res.data;
        let RightData = [];
        Object.keys(this.areaRight).forEach((v) => {
          if (this.areaRight[v].length) {
            RightData = this.areaRight[v];
          }
        });
        this.RightDataNew = RightData;
        // console.log("RightData", this.RightDataNew);
      });
    },
    // 选择时间
    handleTimeChange(value) {
      let cnty;
      this.regions.forEach((ele) => {
        if (ele.value == this.regionValue) {
          cnty = ele.label;
        }
      });
      // console.log("/////", value);
      this.timevalueS = value.join("");
      // console.log("//", this.timevalueS);
      this.getIndexData();
      this.getTableLeft("areaTmApPeople");
      this.getTableRight("coPtApNum");
    },
    // 切换图表图标
    switchEchart(val) {
      switch (val) {
        case 1:
          this.echartsType1 = 1;
          break;
        case 2:
          this.echartsType1 = 2;
          break;
        case 3:
          this.echartsType2 = 3;
          break;
        case 4:
          this.echartsType2 = 4;
          break;
        case 5:
          this.echartsType3 = 5;
          break;
        case 6:
          this.echartsType3 = 6;
          break;
      }
    },
    // 左边数据导出
    downLoadFile() {
      let cnty;
      this.regions.forEach((ele) => {
        if (ele.value == this.regionValue) {
          cnty = ele.label;
        }
      });
      let aLink = document.createElement("a");
      (aLink.href =
        this.$url +
        "home/exportList" +
        // localStorage.getItem("token") +
        "?uid=" +
        localStorage.getItem("uid") +
        "&token=" +
        localStorage.getItem("token") +
        "&cnty=" +
        cnty +
        "&time=" +
        this.timevalueS +
        "&ty=" +
        this.trandeValue),
        aLink.click();
    },
    // 右边数据导出
    downLoadFileRight() {
      let cnty;
      this.regions.forEach((ele) => {
        if (ele.value == this.regionValue) {
          cnty = ele.label;
        }
      });
      let aLink = document.createElement("a");
      (aLink.href =
        this.$url +
        "home/exportList" +
        // localStorage.getItem("token") +
        "?uid=" +
        localStorage.getItem("uid") +
        "&token=" +
        localStorage.getItem("token") +
        "&cnty=" +
        cnty +
        "&time=" +
        this.timevalueS +
        "&ty=" +
        this.companyValue),
        aLink.click();
    },
    // 底部数据导出
    ExportAreaExcel() {
      let cnty;
      this.regions.forEach((ele) => {
        if (ele.value == this.regionValue) {
          cnty = ele.label;
        }
      });
      let aLink = document.createElement("a");
      (aLink.href =
        this.$url +
        "home/exportArea" +
        "?uid=" +
        localStorage.getItem("uid") +
        "&token=" +
        localStorage.getItem("token") +
        "&cnty=" +
        cnty +
        "&time=" +
        this.timevalueS),
        aLink.click();
    },
  },
};
</script>

<style>
.content-back {
  background: #f2f2f2;
  overflow-y: auto;
  height: 100%;
}

.search-box {
  justify-content: flex-end;
  flex: 1;
  /* width: 300px; */
  display: flex;
  padding-top: 14px;
  padding-right: 14px;
}
.el-input {
  font-size: 10px;
}
/* // 下拉框区域样式 */
.analy-one {
  color: #272727;
  position: relative;
  justify-content: flex-end;
  flex: 1;
  display: flex;
  margin: 10px;
}
.analySelect-one {
  font-size: 11px;
  height: 35px;
  width: 120px;
  border: 1px solid #1472d5;
  border-right: 1px solid #dcdfe6;
  border-top-left-radius: 19px;
  border-bottom-left-radius: 19px;
  /* line-height: 36px; */
  padding: 0 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.analy-one .el-input {
  border-radius: 0;
}
.analy-one .el-input__inner {
  border: 0;
  color: #272727;
}
.analy-one .el-input__icon {
  color: #272727;
}
.analy-one .timeblock-one {
  border-left: 1px solid #dcdfe6;
  border-top-right-radius: 19px;
  border-bottom-right-radius: 19px;
  font-size: 12px;
  height: 35px;
  width: 150px;
  border: 1px solid #1472d5;
  padding: 0 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  color: #272727;
}

.analySelect-two {
  border-radius: 19px;
  font-size: 12px;
  /* height: 22px; */
  width: 186px;
  border: 1px solid #1472d5;
  overflow: hidden;
  /* text-overflow: ellipsis;
  white-space: nowrap; */
  cursor: pointer;
  color: #272727;
  margin-top: 12px;
}

.analySelect-two .el-input__inner {
  height: 26px;
  border: none;
}

.analySelect-two .el-input__icon {
  height: 26px;
  position: relative;
  top: 8px;
}
.analySelect-two .el-select .el-input.is-focus .el-input__inner {
  border-color: #fff;
}

.analy-one .el-cascader {
  width: 148px;
  color: #272727;
}
.add-area {
  margin: 0 auto;
  width: 75px;
  height: 20px;
  position: relative;
  color: #8be2ba;
  font-size: 12px;
  cursor: pointer;
}
/* .gaoxin {
  position: absolute;
  bottom: 14%;
  left: 46%;
}
.gaoxin1 {
  position: absolute;
  bottom: 22%;
  left: 46%;
}
.gaoxin2 {
  position: absolute;
  bottom: 17%;
  left: 52%;
}
.gaoxin3 {
  position: absolute;
  bottom: 26%;
  left: 50%;
} */

/* .ss1 {
  bottom: 141px;
  right: -13px;
  position: absolute;
}
.ss2 {
  position: absolute;
  bottom: 144px;
  right: 26px;
}
.ss3 {
  position: absolute;
  bottom: 203px;
  right: 30%;
}
.ss4 {
  position: absolute;
  bottom: 159px;
  right: 36%;
} */
.common-map {
  background-color: #fff;
}

.search-box .el-input__icon {
  line-height: 32px;
}
.line-map {
  flex: 1;
  margin-left: 10px;
  margin-bottom: 10px;
}

.content {
  width: 99%;
  display: flex;
  background-color: #f2f2f2;
}
.map {
  position: relative;
  background: #ffffff;
  border-radius: 4px;
  height: 535px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.08);
}
.downup {
  width: 55px;
  height: 22px;
  border: 0.88px solid #1773d5;
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  text-align: center;
  color: #1773d5;
  line-height: 22px;

  position: absolute;
  top: 11px;
  right: 11px;
  cursor: pointer;
}
.number-list {
  max-width: 95%;
  margin: 10px 0 10px 10px;
}
.number-list .el-table__header-wrapper {
  height: 40px !important;
}
.blankimg-home {
  margin: auto;
  width: 140px;
  height: 130px;
  margin-top: 15%;
}
.blankimg-home > img {
  margin: 0;
}
.blankimg-home > p {
  color: rgb(175, 170, 170);
  text-align: center;
  font-size: 16px;
}
.map-list {
  width: 97%;
  height: 275px;
  margin: 45px 0 10px 10px;
  overflow-y: auto;
}
.map-list .el-table__header-wrapper {
  text-align: center;
}
.table-data {
  margin-top: 10px;
  display: flex;
}
.table-data-left {
  margin-right: 10px;
  width: 50%;
  height: 470px;
  background-color: #fff;
  /* overflow-y: auto; */
}
.table-data-right {
  width: 50%;
  height: 470px;
  background-color: #fff;
  /* overflow-y: auto; */
}
.table-header {
  display: flex;
  position: relative;
}
.table-header::before {
  content: "";
  width: 4px;
  height: 16px;
  background: #2b7bfd;
  border-radius: 2px;
  display: inline-block;
  margin: 15px 13px 0px 10px;
}
.el-card__body {
  padding: 0;
}

.content-right {
  display: flex;
  flex-direction: column;
  width: 60%;
}

.search-title {
  display: flex;
}
.search-sub {
  opacity: 0.85;
  font-size: 16px;
  font-family: LucidaGrande, LucidaGrande-Bold;
  font-weight: 700;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  letter-spacing: -0.2px;
  margin-top: 12px;
  margin-left: 35px;
}
.search-sub::before {
  content: "";
  width: 4px;
  height: 16px;
  background: #2b7bfd;
  border-radius: 2px;
  display: inline-block;
  margin-right: 10px;
  position: absolute;
  left: 18px;
  top: 15px;
}
.line-map-header {
  position: relative;
  z-index: 99;
  height: 1px;
  /* top: 0; */
}
.line-map-header-left {
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
}
.header-title {
  margin-top: 10px;
  margin-left: 23px;
  font-size: 16px;
  letter-spacing: -0.2px;
}
.other-tips {
  font-size: 12px !important;
  margin-top: 7px;
  margin-left: 7px;
}
.header-title::before {
  content: "";
  width: 4px;
  height: 16px;
  background: #2b7bfd;
  border-radius: 2px;
  display: inline-block;
  position: absolute;
  top: 14px;
  left: 8px;
}
/* // 底部区域 */
.list-bottom {
  width: 99%;
  margin-top: 6px;
  background-color: #fff;
}
.home-list-title {
  display: flex;
}
.homelist-tips {
  float:right;
  margin-right: 14px;
}
.home-subtitle {
  opacity: 0.85;
  font-size: 16px;
  line-height: 50px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  font-family: MicrosoftYaHeiSemibold, MicrosoftYaHeiSemibold-Regular;
}
.home-subtitle::before {
  content: "";
  width: 4px;
  height: 16px;
  background: #2b7bfd;
  border-radius: 2px;
  display: inline-block;
  margin: 0px 17px -2px 17px;
}
.list-top {
  display: flex;
  height: 50px;

  justify-content: space-between;
}
.list-out {
  margin: 6px 6px 0px 0px;
}
.home-list-content {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.homeList {
  border: 1px solid #dddddd;
  /* flex-direction: column; */
  margin-left: 10px;
}
/* .homeList:first-child ul {
  min-width: 210px;
} */
/* .homeList:nth-child(2) ul {
  max-width: 630px;
} */
.homeList:nth-child(2) ul li {
  min-width: 34%;
}
/* .homeList:nth-child(3) ul {
  max-width: 559px;
} */
.homeList:nth-child(3) ul li {
  min-width: 45%;
}
/* .homeList:nth-child(4) ul {
  max-width: 300px;
} */
.homeList:nth-child(4) ul li {
  width: 210px;
}

@media screen and (min-width: 720px) {
  .ss1 {
    bottom: 153px;
    right: -23px;
    position: absolute;
  }
  .ss2 {
    position: absolute;
    bottom: 154px;
    right: 21px;
  }
  .ss3 {
    position: absolute;
    bottom: 248px;
    right: 30%;
  }
  .ss4 {
    position: absolute;

    bottom: 168px;
    right: -18%;
  }
}

@media screen and (min-width: 1080px) {
  .ss1 {
    bottom: 155px;
    /* left: -31px; */
    position: absolute;
  }
  .ss2 {
    position: absolute;
    bottom: 148px;
    /* left: -34%; */
  }
  .ss3 {
    position: absolute;
    /* left: -79px; */
  }
  .ss4 {
    position: absolute;
    bottom: 161px;
    /* left: -53%; */
  }
}
/* .home-list-ti {
  display: flex;
} */
/* .homeList:nth-child(1) ul li {

  width: 170px;
}

.homeList:nth-child(2) ul li {
 
 width: 45%;
}

.homeList:nth-child(3) ul li {
  
  width: 194px;
}
.homeList:nth-child(4) ul li {
 
  min-width: 141px;
} */

.homeList > div {
  height: 32px;
  background: #e7f3ff;
  font-size: 16px;
  color: #1773d5;
  line-height: 32px;
  padding-left: 23px;
  font-weight: bold;
}

.homeList ul li {
  font-size: 13px;
  line-height: 4.8vh;
  font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;

  color: rgba(77, 77, 77, 0.85);
  letter-spacing: -0.16px;
}
.homeList ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  list-style: none;
  color: #333333;
  padding: 12px 12px;
  height: auto;
}
.homeList .indexspan {
  align-items: end;
  color: #3388ff;
}
/* // 折线图样式 */
.check-echart {
  top: 0;
  right: -2px;
  z-index: 99;
  position: absolute;
  display: flex;
}
.check-echart > div {
  font-size: 14px;
  color: #0064d0;
  width: 17px;
  height: 27px;
  overflow: hidden;
  margin-right: 12px;
  margin-top: 11px;
  line-height: 29px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.check-echart > div:first-child {
  letter-spacing: 1px;
}
.checked {
  width: 75px !important;
  overflow: visible;
  background: #e7f3ff;
  padding: 0 8px;
}
</style>
